import styled from '@emotion/styled';

export const Row = styled.div`
  display: flex;
  width: 100%;
  gap: 15px;
`;

export const Card = styled.div<{ padding?: string }>`
  background-color: var(--color-background-white);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 50px;
  height: 100vh;
  overflow: auto;
  animation: fadeIn 1s ease-in-out;
  ${({ padding }) =>
    padding && `padding-right: ${padding}px; padding-left: ${padding}px;`}
`;

export const FormWrapper = styled.div<{ padding?: string }>`
  gap: 20px;
  width: 100vw;
  height: 50vh;
  min-width: 350px;
  min-height: 350px;
  ${({ padding }) =>
    padding && `padding-right: ${padding}px; padding-left: ${padding}px;`}
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const InputWrapper = styled.div<{ error?: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 25px;
  flex: 1;
`;

export const Error = styled.div`
  position: absolute;
  width: 100%;
  bottom: -5px;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 36px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: fadeIn 1s ease-in-out;
  text-align: center;
`;

export const VideoWrapper = styled.div`
  max-width: 800px;
  pointer-events: none;
`;

export const CTAWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const Testimonial = styled.div`
  text-align: center;
  padding-top: 60px;
  width: 100%;

  & > div {
    width: 75%;
    margin: 0 auto;
  }
`;
